import { render, staticRenderFns } from "./NewTranshipment.vue?vue&type=template&id=6c230e32"
import script from "./NewTranshipment.vue?vue&type=script&lang=js"
export * from "./NewTranshipment.vue?vue&type=script&lang=js"
import style0 from "./NewTranshipment.vue?vue&type=style&index=0&id=6c230e32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports